<div *ngIf="loader" class="spinner">
  <nx-spinner nxSize="large"></nx-spinner>
</div>

<nx-accordion *ngIf="!loader" [formGroup]="documentMetadataForm"identityRevealed>
  <nx-expansion-panel [expanded]="true">
    <nx-expansion-panel-header>
      <nx-expansion-panel-title
      >Wichtigste Attribute</nx-expansion-panel-title
      >
    </nx-expansion-panel-header>
    <div nxRow>
      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkDocCategoryIsObjectAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsDamageAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsRescheduleAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsEnvAssessmentAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsForeignCustomerAndEncoresFlagTrueFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeOverviewAndHolderIdFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsPolicyHolderAndEncoresFlagTrueFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsContractAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.get('coverProcessIdInvalid')?.errors ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsContractAndDocTypeAllowedFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Vorgang ID"><input nxInput class="form-control"
                                                  formControlName="coverProcessId"
                                                  (change)="validateWithEncores()"
                                                  [(ngModel)]="documentMetadata!.coverProcessId"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.get('coverProcessId')?.hasError('notInteger')">
          {{WRONG_NUMERIC_MSG}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsForeignCustomerAndEncoresFlagTrueFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsForeignCustomerAndEncoresFlagTrueText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsPolicyHolderAndEncoresFlagTrueFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsPolicyHolderAndEncoresFlagTrueText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeOverviewAndHolderIdFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeOverviewAndHolderIdText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.get('coverProcessIdInvalid')?.errors && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{coverProcessIdInvalidText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsContractAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsContractAndDocTypeAllowedText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsObjectAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsObjectAndDocTypeAllowedText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsDamageAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsDamageAndDocTypeAllowedText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsRescheduleAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsRescheduleAndDocTypeAllowedText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsEnvAssessmentAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsEnvAssessmentAndDocTypeAllowedText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsContractAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsContractAndDocTypeAllowedText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.coverProcessId"><nx-checkbox (change)="showOptions($event, 'coverProcessId')"></nx-checkbox></div>
    </div>
    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkPolicyHolderIdGreaterThan1000Flag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeInvoiceAndHolderIdFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeCompInfoFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsForeignCustomerAndEncoresFlagTrueFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeNoteAndCategoryNotApgFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsDnAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeSaleAndCategoryNotApgFlag'] ||
                                                  documentMetadataForm.get('policyHolderIdInvalid')?.errors ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Personennummer DN"><input nxInput
                                                         class="form-control"
                                                         formControlName="policyHolderId"
                                                         (change)="validateWithEncores()"
                                                         [(ngModel)]="documentMetadata!.policyHolderId"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.get('policyHolderId')?.hasError('notInteger')">
          {{WRONG_NUMERIC_MSG}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeSaleAndCategoryNotApgFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeSaleAndCategoryNotApgText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsForeignCustomerAndEncoresFlagTrueFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsForeignCustomerAndEncoresFlagTrueText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeNoteAndCategoryNotApgFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeNoteAndCategoryNotApgText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.get('policyHolderIdInvalid')?.errors && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{policyHolderIdInvalidText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeCompInfoFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeCompInfoText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeInvoiceAndHolderIdFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeInvoiceAndHolderIdText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkPolicyHolderIdGreaterThan1000Flag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkPolicyHolderIdGreaterThan1000Text}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsDnAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsDnAndDocTypeAllowedText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.policyHolderId"><nx-checkbox (change)="showOptions($event, 'policyHolderId')"></nx-checkbox></div>
    </div>
    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkDocCategoryIsAkAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsObjectAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsDamageAndDocTypeAllowedFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeCompInfoFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocCategoryIsPolicyHolderAndEncoresFlagTrueFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeOverviewAndHolderIdFlag'] ||
                                                  documentMetadataForm.get('foreignCustomerIdInvalid')?.errors ||
                                                  documentMetadataForm.errors?.['checkDocTypesAndCategoryAllowedFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Personennummer AK"><input nxInput    class="form-control"
                                                         formControlName="foreignCustomerId"
                                                         (change)="validateWithEncores()"
                                                         [(ngModel)]="documentMetadata!.foreignCustomerId"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.get('foreignCustomerId')?.hasError('notInteger')">
          {{WRONG_NUMERIC_MSG}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.get('foreignCustomerIdInvalid')?.errors && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{foreignCustomerIdInvalidText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsPolicyHolderAndEncoresFlagTrueFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsPolicyHolderAndEncoresFlagTrueText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeCompInfoFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeCompInfoText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeOverviewAndHolderIdFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeOverviewAndHolderIdText}}
        </nx-error>
      <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsDamageAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
        {{checkDocCategoryIsDamageAndDocTypeAllowedText}}
      </nx-error>
      <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsObjectAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
        {{checkDocCategoryIsObjectAndDocTypeAllowedText}}
      </nx-error>
      <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsAkAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
        {{checkDocCategoryIsAkAndDocTypeAllowedText}}
      </nx-error>
      <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypesAndCategoryAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
        {{checkDocTypesAndCategoryAllowedText}}
      </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.foreignCustomerId"><nx-checkbox (change)="showOptions($event, 'foreignCustomerId')"></nx-checkbox></div>
    </div>
    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkDocCategoryIsApgAndDocTypeAllowedFlag'] ||
                                                    documentMetadataForm.get('contractNumberInvalid')?.errors) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Vertrag APG"><input nxInput   class="form-control"
                                                   formControlName="contractNumber"
                                                   (change)="validateWithEncores()"
                                                   [(ngModel)]="documentMetadata!.contractNumber"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.get('contractNumber')?.hasError('notInteger')">
          {{WRONG_NUMERIC_MSG}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryIsApgAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryIsApgAndDocTypeAllowedText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.get('contractNumberInvalid')?.errors && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{contractNumberInvalidText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.contractNumber"><nx-checkbox (change)="showOptions($event, 'contractNumber')"></nx-checkbox></div>
    </div>

    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkSpecialDocumentTypeWithCountryExistFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeNoteAndCategoryNotApgFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocTypeSaleAndCategoryNotApgFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Land">
          <nx-dropdown [(ngModel)]="documentMetadata!.country" class="form-control" formControlName="country">
            <nx-dropdown-item
              *ngFor="let country of countriesData"
              nxValue="{{country.key}}"
            >{{country.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeNoteAndCategoryNotApgFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeNoteAndCategoryNotApgText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeSaleAndCategoryNotApgFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeSaleAndCategoryNotApgText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkSpecialDocumentTypeWithCountryExistFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkSpecialDocumentTypeWithCountryExistsText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.country"><nx-checkbox (change)="showOptions($event, 'country')"></nx-checkbox></div>
    </div>

    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkDocumentDatesValidFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Dokumentdatum">
          <input
            nxDatefield
            nxInput
            [nxDatepicker]="DokumentdatumDatepicker"
            [(ngModel)]="documentMetadata!.documentDate"
            class="form-control" formControlName="documentDate"
          />
          <nx-datepicker-toggle
            [for]="DokumentdatumDatepicker"
            nxFormfieldSuffix
          ></nx-datepicker-toggle>
          <nx-datepicker #DokumentdatumDatepicker></nx-datepicker>
        </nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocumentDatesValidFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocumentDateIsValidText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentDate"><nx-checkbox (change)="showOptions($event, 'documentDate')"></nx-checkbox></div>
    </div>

    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkDocCategoryAndDocTypeAllowedFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Dokumentkategorie" id="documentCategory">
          <nx-dropdown [(ngModel)]="documentMetadata!.documentCategory"  class="form-control"
                       formControlName="documentCategory"
                       (selectionChange)="dependenciesForDocumentCategoryAndDocumentType($event.value)">
            <nx-dropdown-item
              *ngFor="let documentCategory of documentCategoryData"
              nxValue="{{documentCategory.key}}"
            >{{documentCategory.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryAndDocTypeAllowedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryAndDocTypeAllowedText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentCategory"><nx-checkbox (change)="showOptions($event, 'documentCategory')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Dokument Typ" id="documentType">
          <nx-dropdown [(ngModel)]="documentMetadata!.documentType" class="form-control"
                       formControlName="documentType" >
            <div *ngIf="documentTypeDataPossibilities.length > 0">
              <nx-dropdown-item
                *ngFor="let documentType of documentTypeDataPossibilities"
                nxValue="{{documentType.key}}"
              >{{documentType.value}}</nx-dropdown-item>
            </div>
            <div *ngIf="documentTypeDataPossibilities.length === 0">
              <nx-dropdown-item
                *ngFor="let documentType of documentTypeData"
                nxValue="{{documentType.key}}"
              >{{documentType.value}}</nx-dropdown-item>
            </div>
          </nx-dropdown>
        </nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentType"><nx-checkbox (change)="showOptions($event, 'documentType')"></nx-checkbox></div>
    </div>

    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkSpecialDocumentTypeWithDocTitleExistFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Dokument Titel"><input nxInput     name="documentTitle"  class="form-control"
                                                      formControlName="documentTitle" [(ngModel)]="documentMetadata!.documentTitle"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkSpecialDocumentTypeWithDocTitleExistFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkSpecialDocumentTypeWithDocTitleExistsText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentTitle"><nx-checkbox (change)="showOptions($event, 'documentTitle')"></nx-checkbox></div>
    </div>
    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkDocCategoryAndDocStatusStatusAllowFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Dokument bearbeitet">
          <nx-dropdown [(ngModel)]="documentMetadata!.documentProcessed" class="form-control" formControlName="documentProcessed" >
            <nx-dropdown-item
              *ngFor="let documentProcessed of documentProcessedData"
              nxValue="{{documentProcessed.key}}"
            >{{documentProcessed.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryAndDocStatusStatusAllowFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryAndDocStatusAllowText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentProcessed"><nx-checkbox (change)="showOptions($event, 'documentProcessed')"></nx-checkbox></div>
    </div>

    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkSpecialDocumentTypeIsFilledWithNoteFlag'] ||
                                                  documentMetadataForm.errors?.['checkDocStatusAndJustificationFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Dokumenten Notiz"><input nxInput   class="form-control"
                                                        formControlName="documentNotes"
                                                        [(ngModel)]="documentMetadata!.documentNotes"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkSpecialDocumentTypeIsFilledWithNoteFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkSpecialDocumentTypeIsFilledWithNoteText}}
        </nx-error>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocStatusAndJustificationFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocStatusAndJustificationText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentNotes"><nx-checkbox (change)="showOptions($event, 'documentNotes')"></nx-checkbox></div>
    </div>

    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkDocCategoryAndDocStatusStatusAllowFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Dokument Status">
          <nx-dropdown [(ngModel)]="documentMetadata!.documentStatus" class="form-control" formControlName="documentStatus" >
            <nx-dropdown-item
              *ngFor="let documentStatus of documentStatusData"
              nxValue="{{documentStatus.key}}"
            >{{documentStatus.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocCategoryAndDocStatusStatusAllowFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocCategoryAndDocStatusAllowText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentStatus"><nx-checkbox (change)="showOptions($event, 'documentStatus')"></nx-checkbox></div>
    </div>

    <div nxRow>

      <div nxCol="11">
        <nx-formfield nxLabel="Dokument Status Timestamp"><input nxInput   class="form-control"
                                                                 formControlName="documentStatusTimestamp"
                                                                 [(ngModel)]="documentMetadata!.documentStatusTimestamp"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentStatusTimestamp"><nx-checkbox (change)="showOptions($event, 'documentStatusTimestamp')"></nx-checkbox></div>
    </div>
  </nx-expansion-panel>
  <nx-expansion-panel>
    <nx-expansion-panel-header>
      <nx-expansion-panel-title
      >Weitere Attribute</nx-expansion-panel-title
      >
    </nx-expansion-panel-header>

    <div nxRow>

      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkEmailRecipientFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="E-Mail Empfänger"><input nxInput    class="form-control"
                                                        formControlName="emailReceipt"
                                                        [(ngModel)]="documentMetadata!.emailReceipt"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkEmailRecipientFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkEmailRecipientText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.emailReceipt"><nx-checkbox (change)="showOptions($event, 'emailReceipt')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="E-Mail Kopie an"><input nxInput   class="form-control"
                                                       formControlName="emailCopyTo"
                                                       [(ngModel)]="documentMetadata!.emailCopyTo"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.emailCopyTo"><nx-checkbox (change)="showOptions($event, 'emailCopyTo')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="E-Mail Thema"><input nxInput   class="form-control"
                                                    formControlName="emailSubject"   [(ngModel)]="documentMetadata!.emailSubject"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.emailSubject"><nx-checkbox (change)="showOptions($event, 'emailSubject')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['i']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="E-Mail Zeitstempel"><input nxInput   class="form-control"
                                                          formControlName="emailSendTimestamp"  [(ngModel)]="documentMetadata!.emailSendTimestamp"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkEmailChangedFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkEmailChangedText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.emailSendTimestamp"><nx-checkbox (change)="showOptions($event, 'emailSendTimestamp')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkDocTypeInvoiceAndHolderIdFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Rechnung Nummer"><input nxInput    class="form-control"
                                                       formControlName="invoiceNumber"  [(ngModel)]="documentMetadata!.invoiceNumber"/></nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkDocTypeInvoiceAndHolderIdFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkDocTypeInvoiceAndHolderIdText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.invoiceNumber"><nx-checkbox (change)="showOptions($event, 'invoiceNumber')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Eingang Ausgang">
          <nx-dropdown [(ngModel)]="documentMetadata!.inOutFlag"
                       class="form-control"
                       formControlName="inOutFlag" >
            <nx-dropdown-item
              *ngFor="let inOutFlag of inOutFlagData"
              nxValue="{{inOutFlag.key}}"
            >{{inOutFlag.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.inOutFlag"><nx-checkbox (change)="showOptions($event, 'inOutFlag')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Dokument Kanal">
          <nx-dropdown [(ngModel)]="documentMetadata!.documentChannel"
                       class="form-control"
                       formControlName="documentChannel" >
            <nx-dropdown-item
              *ngFor="let documentChannel of documentChannelData"
              nxValue="{{documentChannel.key}}"
            >{{documentChannel.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentChannel"><nx-checkbox (change)="showOptions($event, 'documentChannel')"></nx-checkbox></div>
    </div>


  </nx-expansion-panel>
  <nx-expansion-panel>
    <nx-expansion-panel-header>
      <nx-expansion-panel-title
      >Selten gebrauchte Attribute</nx-expansion-panel-title
      >
    </nx-expansion-panel-header>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Dokument Anzahl Seiten"><input nxInput    class="form-control"
                                                              formControlName="documentPagesNo"
                                                              [(ngModel)]="documentMetadata!.documentPagesNo"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentPagesNo"><nx-checkbox (change)="showOptions($event, 'documentPagesNo')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11" [ngClass]="{'error-field': (documentMetadataForm.errors?.['checkConfidentialityLevelFlag']) &&
                                                                    (documentMetadataForm.touched || documentMetadataForm.dirty)}">
        <nx-formfield nxLabel="Vertraulichkeitsstufe">
          <nx-dropdown [(ngModel)]="documentMetadata!.confidentialityLevel"
                       class="form-control"
                       formControlName="confidentialityLevel" >
            <nx-dropdown-item
              *ngFor="let confidentialityLevel of confidentialityLevelData"
              nxValue="{{confidentialityLevel.key}}"
            >{{confidentialityLevel.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
        <nx-error class="nx-margin-bottom-m" *ngIf="documentMetadataForm.errors?.['checkConfidentialityLevelFlag'] && (documentMetadataForm.touched || documentMetadataForm.dirty)">
          {{checkConfidentialityLevelText}}
        </nx-error>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.confidentialityLevel"><nx-checkbox (change)="showOptions($event, 'confidentialityLevel')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Datenschutz">
          <nx-dropdown [(ngModel)]="documentMetadata!.dataProtection"
                       class="form-control"
                       formControlName="dataProtection" >
            <nx-dropdown-item
              *ngFor="let dataProtection of dataProtectionData"
              nxValue="{{dataProtection.key}}"
            >{{dataProtection.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.dataProtection"><nx-checkbox (change)="showOptions($event, 'dataProtection')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Barcode"><input nxInput   class="form-control"
                                               formControlName="barcode"
                                               [(ngModel)]="documentMetadata!.barcode"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.barcode"><nx-checkbox (change)="showOptions($event, 'barcode')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Barcode Gruppe"><input nxInput   class="form-control"
                                                      formControlName="barcodeGroup"
                                                      [(ngModel)]="documentMetadata!.barcodeGroup"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.barcodeGroup"><nx-checkbox (change)="showOptions($event, 'barcodeGroup')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Papierarchiv Referenze"><input nxInput   class="form-control"
                                                              formControlName="paperArchiveReference"
                                                              [(ngModel)]="documentMetadata!.paperArchiveReference"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.paperArchiveReference"><nx-checkbox (change)="showOptions($event, 'paperArchiveReference')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Papierarchiv Referenze 2"><input nxInput   class="form-control"
                                                                formControlName="paperArchiveReference2"
                                                                [(ngModel)]="documentMetadata!.paperArchiveReference2"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.paperArchiveReference2"><nx-checkbox (change)="showOptions($event, 'paperArchiveReference2')"></nx-checkbox></div>
    </div>


  </nx-expansion-panel>
  <nx-expansion-panel>
    <nx-expansion-panel-header>
      <nx-expansion-panel-title
      >Systemattribute</nx-expansion-panel-title
      >
    </nx-expansion-panel-header>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Änderungs User"><input nxInput    class="form-control"
                                                      formControlName="changeUser"   [(ngModel)]="documentMetadata!.changeUser"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.changeUser"><nx-checkbox (change)="showOptions($event, 'changeUser')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Liefer System">
          <nx-dropdown [(ngModel)]="documentMetadata!.deliverySystem"
                       class="form-control"
                       formControlName="deliverySystem" >
            <nx-dropdown-item
              *ngFor="let deliverySystem of deliverySystemData"
              nxValue="{{deliverySystem.key}}"
            >{{deliverySystem.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.deliverySystem"><nx-checkbox (change)="showOptions($event, 'deliverySystem')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Mime Type"><input nxInput   class="form-control"
                                                 formControlName="documentMimeType"
                                                 [(ngModel)]="documentMetadata!.documentMimeType"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentMimeType"><nx-checkbox (change)="showOptions($event, 'documentMimeType')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Lade Datum">
          <input
            nxDatefield
            nxInput
            [nxDatepicker]="loadDateDatepicker"
            [(ngModel)]="documentMetadata!.loadDate"
            class="form-control"
            formControlName="loadDate"
          />
          <nx-datepicker-toggle
            [for]="loadDateDatepicker"
            nxFormfieldSuffix
          ></nx-datepicker-toggle>
          <nx-datepicker #loadDateDatepicker></nx-datepicker>
        </nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.loadDate"><nx-checkbox (change)="showOptions($event, 'loadDate')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Lade Zeit"><input nxInput   class="form-control"
                                                 formControlName="loadTime"
                                                 [(ngModel)]="documentMetadata!.loadTime"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.loadTime"><nx-checkbox (change)="showOptions($event, 'loadTime')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Lade User"><input nxInput   class="form-control"
                                                 formControlName="loadUser"
                                                 [(ngModel)]="documentMetadata!.loadUser"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.loadUser"><nx-checkbox (change)="showOptions($event, 'loadUser')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Fehler Text"><input nxInput   class="form-control"
                                                   formControlName="documentError"
                                                   [(ngModel)]="documentMetadata!.documentError"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.documentError"><nx-checkbox (change)="showOptions($event, 'documentError')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Job ID"><input nxInput   class="form-control"
                                              formControlName="jobId"
                                              [(ngModel)]="documentMetadata!.jobId"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.jobId"><nx-checkbox (change)="showOptions($event, 'jobId')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Lösch Datum">
          <input
            nxDatefield
            nxInput
            [nxDatepicker]="retentionDateDatepicker"
            [(ngModel)]="documentMetadata!.retentionDate"
            class="form-control"
            formControlName="retentionDate"
          />
          <nx-datepicker-toggle
            [for]="retentionDateDatepicker"
            nxFormfieldSuffix
          ></nx-datepicker-toggle>
          <nx-datepicker #retentionDateDatepicker></nx-datepicker>
        </nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.retentionDate"><nx-checkbox (change)="showOptions($event, 'retentionDate')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="DUI"><input nxInput   class="form-control"
                                           formControlName="dui"
                                           [(ngModel)]="documentMetadata!.dui"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.dui"><nx-checkbox (change)="showOptions($event, 'dui')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="S3 Pfad"><input nxInput   class="form-control"
                                               formControlName="s3Path"
                                               [(ngModel)]="documentMetadata!.s3Path"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.s3Path"><nx-checkbox (change)="showOptions($event, 's3Path')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="EDMID"><input nxInput class="form-control"
                                             formControlName="edmId"
                                             [(ngModel)]="documentMetadata!.edmId"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.edmId"><nx-checkbox (change)="showOptions($event, 'edmId')"></nx-checkbox></div>
    </div>

    <div nxRow>
      <div nxCol="11">
        <nx-formfield nxLabel="Original Dokument ID"><input nxInput   class="form-control"
                                                            formControlName="originalId"
                                                            [(ngModel)]="documentMetadata!.originalId"/></nx-formfield>
      </div>
      <div nxCol="1" *ngIf="showCheckbox && documentMetadata!.originalId"><nx-checkbox (change)="showOptions($event, 'originalId')"></nx-checkbox></div>
    </div>
  </nx-expansion-panel>
</nx-accordion>
